import React, { Component } from "react";
import Helping from "../../helpers/Helping";
import { create, update } from "../../services/pages.service";
import { setErrorFields, validateField, validateCallback } from "../../helpers/validationHelpers";
import { connect } from "react-redux";
import { MESSAGE } from '../../config/index';
import { API_URL } from '../../config/urls';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import Editor from "../layout/Editor";
import Notification from "../layout/Notification";
import LoadingButton from "../fields/LoadingButton";
import Service from '../../helpers/service';
import $ from 'jquery';

const { EMPTY, CREATE, UPDATE } = MESSAGE;
class Create extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageTitle: 'Add New Page',
            buttonTitle: 'Save',
            title: '',
            code: '',
            content: "",
            url: API_URL.ADMIN_TRADING_API + "pages",
            routeName: "/pages",
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsDisable: false,
        };
        this.onUpdate = this.onUpdate.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    setErrorOnApiCall = () => {
        setProfileError((res) =>
            this.setState({ ...res })
        );
    };

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    };

    setValidationCallback = () => {
        validateCallback((res) => this.setState({ ...res }));
    };

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    handleChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === 'title')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'code')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'content')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
    }

    componentDidMount() {
        let that = this;
        this.setErrorOnApiCall();
        this.setValidationCallback();

        if (!this.props.id) {
            this.setState({
                isLoading: false,
            });
        }
        if (this.props.id) {
            let id = this.props.id;
            that.setState({
                pageTitle: 'Edit Page',
                buttonTitle: 'Update',
            });

            that.getById(id);
        }

        $(".close-slide").click(function () {
            that.resetForm();
            that.removeNetworkError();
            that.setState({
                pageTitle: 'Add New Page',
                buttonTitle: 'Save'
            })
            that.props.closeEditModal();
        });
    }

    checkEmptyFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.title != null && state.title.length < 1) {
            let errorObject = setErrorFields(
                'title',
                Helping.getMessageString(EMPTY, 'Title')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.code != null && state.code.length < 1) {
            let errorObject = setErrorFields(
                'code',
                Helping.getMessageString(EMPTY, 'Code')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        return formHasError;
    };

    getById(id) {
        var $this = this;

        let data = {
            action: "get-by-id",
            id: id
        }
        Service.postCall(this.state.url, data)
            .then((response) => {
                var page = response.data.payload;

                $this.setState({
                    title: page.title,
                    code: page.code,
                    content: page.content,
                    isLoading: false,
                });
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        isLoading: false,
                    });
                }
                return this.setState({
                    isLoading: false,
                    ...Helping.setNetworkRequestError(error, 'fetching page'),
                });
            });
    }

    resetForm = () => {
        this.setState({
            title: '',
            code: '',
            content: '',
            isLoading: true,
            btnIsDisable: false,
            error_title_message: '',
            error_code_message: '',
            error_content_message: '',
        })
    }

    onSave(event) {
        event.preventDefault();

        let $this = this;
        let formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            action: "create",
            title: this.state.title,
            // code: this.state.code,
            content: this.state.content
        };

        Service.postCall(this.state.url, data)
            .then((response) => {
                this.props.create(response.data.payload);

                $this.setState({
                    error_message: Helping.getMessageString(CREATE, 'Page'),
                    error_type: 'success',
                    btnIsDisable: false
                },
                    () => { this.scrollToTop(); this.resetForm(); })
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState(
                        {
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsDisable: false,
                        },
                        () => { this.scrollToTop(); }
                    );
                }
                return this.setState({
                    isLoading: false,
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, 'creating page'),
                },
                    () => { this.scrollToTop(); }
                );
            });
    }

    onUpdate(event) {
        event.preventDefault();

        let $this = this;
        let formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            action: "update",
            id: this.props.id,
            title: this.state.title,
            // code: this.state.code,
            content: this.state.content
        };

        Service.postCall(this.state.url, data)
            .then((response) => {
                this.props.update(response.data.payload);

                $this.setState({
                    error_message: Helping.getMessageString(UPDATE, 'Page'),
                    error_type: 'success',
                    btnIsDisable: false
                },
                    () => { this.scrollToTop(); })
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState(
                        {
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsDisable: false,
                        },
                        () => { this.scrollToTop(); }
                    );
                }
                return this.setState({
                    isLoading: false,
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, 'updating page'),
                },
                    () => { this.scrollToTop(); }
                );
            });
    }

    render() {
        return (
            <div class="addButton-slide right-slider add-news">
                <div class="slide-top">
                    <div class="slide-header">
                        <h4 class="title">{this.state.pageTitle}</h4>
                        <span class="caption">{this.state.pageTitle} and give information about them.</span>
                    </div>
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }

                <form class="info">
                    <div class="form-group">
                        <label for="pageTitle">Title</label>
                        <input type="text" name="title" value={this.state.title} class={`form-control ${this.state.error_title_message ? 'error-input' : ''}`} id="pageTitle" onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_title_message}</span>
                    </div>
                    {/* <div class="form-group">
                        <label for="pageCode">Code</label>
                        <input type="text" value={this.state.code} name="code" class={`form-control ${this.state.error_code_message ? 'error-input' : ''}`} id="pageCode" onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_code_message}</span>
                    </div> */}
                    <div class="form-group">
                        <label for="pageContent">Content</label>
                        <Editor initialValue={this.state.content} id="pageContent" name="content" classes={`form-control ${this.state.error_content_message ? "error-input" : ""}`} handleChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_content_message}</span>
                    </div>

                    <div class="slide-btn">
                        <div className="float-left">
                            <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                        </div>

                        <div class="float-right">
                            {!this.props.id &&
                                <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>
                            }
                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                this.props.id ? (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onUpdate(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                ) : (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                )}
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}


const mapStateToProps = state => ({
    profile: state.profile
})

const mapDispatchToProps = {
    create,
    update,
    addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(Create)